<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`编辑业务委托样品收费单价`"
    width="900px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="报告编号">
            <el-input disabled v-model="detailData.reportCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托单位">
            <el-input disabled v-model="detailData.client" placeholder="t3" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目名称">
            <el-input disabled v-model="detailData.projectName" placeholder="t3" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-table border :data="editForm.priceTable" :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
            <el-table-column prop="testItemText" label="检测项目" align="center"></el-table-column>
            <el-table-column prop="totalCnt" label="数量" align="center"></el-table-column>
            <el-table-column prop="unitPrice" label="收费单价（元）" align="center">
              <template v-slot="{ row }">
                <el-input type="number" v-model="row.unitPrice" placeholder="请输入收费单价" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="totalPrice" label="收费小计（元）" align="center">
              <template v-slot="{ row }">
                {{ row | formatMoney }}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getReportInvoiceCodeInfo, editSampleInfoPrice } from '@/api/invoice';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeRowId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      detailLoading: false,
      detailData: {},
      editForm: {
        priceTable: []
      },
      rules: {
        invoiceCode: [{ required: true, message: '请输入发票号', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  filters: {
    formatMoney(row) {
      if (!row.totalCnt || !row.unitPrice) return 0;
      return (row.totalCnt * row.unitPrice).toFixed(2);
    },
    stmtWayFilter(stmtWay) {
      switch (stmtWay) {
        case 0:
          return '合同';
        case 1:
          return '现付';
        case 2:
          return '统一开票';
        default:
          return '暂无';
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      const { data } = await getReportInvoiceCodeInfo({ id: this.activeRowId });
      this.detailData = data;
      this.detailData.testItemText = data?.infoList?.[0]?.testItemText || '';
      const priceTable = data?.infoList || [];
      this.editForm.priceTable = [...priceTable];
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const params = { entrustmentId: this.detailData.id, infoList: this.editForm.priceTable };

          try {
            await editSampleInfoPrice(params);

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
